import { useEffect, useState } from 'react'
import { FaCirclePlus, FaCircleMinus } from "react-icons/fa6";
import SportsMatchesList from '../../components/SportsMatchesList';
import { motion, AnimatePresence } from 'framer-motion';
import { useGradientColor, usePrimaryColor, usePrimaryTextColor } from '../../hooks/useThemeColors';

function SportMatchList({ sportId = 4, filter = "Inplay", sportTitle = "Cricket", matchesList = [] }) {
    const [showMatchList, setShowMatchList] = useState(true);
    const [filteredMatchList, setFilteredMatchList] = useState([]);
      const PrimaryColor = usePrimaryColor()
  const PrimaryTextColor = usePrimaryTextColor()
  const gradiantcolor = useGradientColor()

    console.log({ matchesList });

    useEffect(() => {
        if (filter === "Inplay") {
            const filteredMatches = matchesList.filter(match =>
                match?.matchOdds?.some(odds => odds?.inplay)
            );
            setFilteredMatchList(filteredMatches);
        } else if (filter === "Today") {
            const today = new Date();
            const filteredMatches = matchesList.filter(match => {
                const matchDate = new Date(match?.openDate);
                return (
                    matchDate.getDate() === today.getDate() &&
                    matchDate.getMonth() === today.getMonth() &&
                    matchDate.getFullYear() === today.getFullYear()
                );
            });
            setFilteredMatchList(filteredMatches);
        } else { // "Tomorrow"
            const today = new Date();
            const tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);

            const filteredMatches = matchesList.filter(match => {
                const matchDate = new Date(match?.openDate);
                return (
                    matchDate.getDate() === tomorrow.getDate() &&
                    matchDate.getMonth() === tomorrow.getMonth() &&
                    matchDate.getFullYear() === tomorrow.getFullYear()
                );
            });
            setFilteredMatchList(filteredMatches);
        }

        return () => {
            // Optional cleanup
        };
    }, [matchesList, filter]);



    return (
        <div className="flex flex-col w-full py-1 px-2 border-tl-md mb-1">
            <div className="flex flex-row min-h-7 justify-between items-center py-2 px-3 rounded-tl-md rounded-tr-md" style={{
                background: gradiantcolor
            }}
                onClick={() => setShowMatchList(prev => !prev)}
            >
                <p className='text-sm text-white font-semibold'> {sportTitle}
                    <span className='px-3 py-0.5 text-xs font-semibold bg-[#4f9f21] rounded-xl ml-2'>
                        {filteredMatchList?.length > 0 ? filteredMatchList.length.toString() : 0}
                    </span>
                </p>
                <button className='text-white'>
                    {showMatchList ? <FaCircleMinus size={18} /> : <FaCirclePlus size={18} />}
                </button>
            </div>
            <AnimatePresence initial={false}>
                {showMatchList && (
                    <motion.div
                        key="matchList"
                        className="flex-row border rounded-b-md shadow-sm overflow-y-auto bg-white dark:bg-dark-bg "
                        style={{ maxHeight: "50vh" }}
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        <SportsMatchesList sportId={sportId} sportName={sportTitle} matchesList={filteredMatchList} compactDesign={true} />
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    )
}

export default SportMatchList